import { render, staticRenderFns } from "./BCXContentArea.vue?vue&type=template&id=5b4c487a&scoped=true"
import script from "./BCXContentArea.vue?vue&type=script&lang=ts"
export * from "./BCXContentArea.vue?vue&type=script&lang=ts"
import style0 from "./BCXContentArea.vue?vue&type=style&index=0&id=5b4c487a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4c487a",
  null
  
)

export default component.exports